module.exports = __webpack_public_path__ + "static/media/h1_intro.6b87dd08.webp";